<template>
    <transition mode="out-in" @leave="animateOutOverlay" :css="false">
        <div class="welcomeOverlay overlay" v-if="welkomOverlay != true" @click.self="checkForMobile">
            <div class="welkom-panel">
                <div class="purple-panel">
                    <button @click="checkForMobile" class="closeBtn">&times;</button>
                    <div class="info-panel">
                        <h2>WELKOM</h2>
                        <p>FIELD-LAB is een ontwikkelingsfaciliteit voor nieuwe nucleaire medicijnen gericht op de behandeling van kanker. Het helpt het proces van ontwikkeling tot marktlancering te versnellen.<br><br>Op dit platform vind je informatie over FIELD-LAB en alle betrokken partijen.<br><br>Navigeer door het gebouw met behulp van scrollen, swipen of de knoppen rechts in beeld.</p>
                        <button @click="checkForMobile">Ontdek</button>
                    </div>
                    <img class="logo" src="/static/img/Field-Lab_Logo.svg"/>
                </div>
            </div>
        </div>
    </transition>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { TimelineMax } from '@/vendor';
    import screenfull from 'screenfull';
    import { browserCheck } from '@/app/mixins';
    export default {
        mixins: [ browserCheck ],
        data()
        {
            return {
                welkomOverlay: false
            };
        },
        mounted()
        {
            // console.log( this.browserCheck.isChrome );
        },
        methods: {
            animateOutOverlay( el, done )
            {
                let tl = new TimelineMax({
                    onComplete: () =>
                    {
                        done();
                        this.$emit( 'hide' );
                    }
                });

                tl.to( '.welcomeOverlay', 0.35, { autoAlpha: 0, ease: Linear.easeNone }, 0 );
                tl.to( '.welkom-panel', 0.15, { scale: 0.75, autoAlpha: 0, ease: Linear.easeNone }, 0 );

                tl.play();
            },

            checkForMobile()
            {
                if( this.browserCheck.isMobile === true && screenfull.isEnabled )
                {
                    screenfull.request();
                }
                this.welkomOverlay = true;
            }
        }
    };
</script>
